import { create } from 'zustand';

export interface NowPlayingTrack {
  title: string;
  artist: string;
  artwork: string;
  duration: number;
  album?: string;
  albumId?: string;
  trackId?: string;
  format?: string;
  bitDepth?: number;
  sampleRate?: number;
  source?: string;
}

export type NowPlayingSource = 'idle' | 'radio' | 'local' | 'connector';
export type NowPlayingStatus = 'idle' | 'loading' | 'playing' | 'paused' | 'error';

interface NowPlayingState {
  track: NowPlayingTrack | null;
  source: NowPlayingSource;
  status: NowPlayingStatus;

  /** Call when a track actually starts playing from any source */
  setTrack: (track: NowPlayingTrack, source: NowPlayingSource) => void;
  /** Call when playback state changes WITHOUT a track change */
  setStatus: (status: NowPlayingStatus) => void;
  /** Clear everything (e.g. on explicit stop) */
  clear: () => void;
}

export const useNowPlayingStore = create<NowPlayingState>((set) => ({
  track: null,
  source: 'idle',
  status: 'idle',

  setTrack: (track, source) => set({ track, source, status: 'playing' }),
  setStatus: (status) => set((s) => (s.track ? { status } : s)),
  clear: () => set({ track: null, source: 'idle', status: 'idle' }),
}));
